(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeContactInfoSecondaryController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // Toggle Direct Line 
        $scope.toggleDirectLine = function () {
            $scope.secLocation.DirectLine = !$scope.secLocation.DirectLine;
            $scope.pageIsDirty();
        };

        // Toggle Is Public Mobile Phone
        $scope.toggleIsPublicMobilePhone = function () {
            $scope.secLocation.IsPublicMobilePhone = !$scope.secLocation.IsPublicMobilePhone;
            $scope.pageIsDirty();
        };

        // Get Office Code
        $scope.getOfficeCode = function (empXrefLocationId) {
            if (!$scope.employeeXrefLocations) return;
            if (_.isUndefined(empXrefLocationId)) return;

            return _.find($scope.employeeXrefLocations, { EmployeeXRefLocationID: empXrefLocationId }).OfficeCode;
        }

        // Get Location To Display
        $scope.getLocationToDisplay = function (empXrefLocationId) {
            if (!$scope.employeeXrefLocations) return;
            if (_.isUndefined(empXrefLocationId)) return;

            return _.find($scope.employeeXrefLocations, { EmployeeXRefLocationID: empXrefLocationId }).displayName;
        }

        // Get Address
        $scope.getAddress = function (empXrefLocationId) {
            if (!$scope.employeeXrefLocations) return;

            return _.find($scope.employeeXrefLocations, { EmployeeXRefLocationID: empXrefLocationId }).Address;
        }

        // Remove Secondary Location
        $scope.removeSecondaryLocation = function (secLoc) {
            $scope.employeeWithLocations.EmployeeSecondaryLocations =
                _.reject($scope.employeeWithLocations.EmployeeSecondaryLocations, {
                    EmployeeSecondaryLocationID: secLoc.EmployeeSecondaryLocationID
                });

            $scope.pageIsDirty();
        }
    }
})();